import { render, staticRenderFns } from "./setbank.vue?vue&type=template&id=15e4ad04&"
import script from "./setbank.vue?vue&type=script&lang=js&"
export * from "./setbank.vue?vue&type=script&lang=js&"
import style0 from "./setbank.vue?vue&type=style&index=0&id=15e4ad04&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports